import { useEffect, useState } from "react";
import { isMhwMaintenanceActive } from "../constants/maintenance";

const RECHECK_INTERVAL_MS = 60 * 1000;

/**
 * 의정원 점검 시간창 안인지 여부. 화면을 새로고침하지 않아도 1분마다 다시 판정한다.
 */
export const useMhwMaintenance = (): boolean => {
  const [isActive, setIsActive] = useState(() => isMhwMaintenanceActive());

  useEffect(() => {
    const timer = window.setInterval(() => {
      setIsActive(isMhwMaintenanceActive());
    }, RECHECK_INTERVAL_MS);
    return () => window.clearInterval(timer);
  }, []);

  return isActive;
};
